export default __webpack_public_path__ + "static/media/3334 spice rack D top.4f3b5f67.png";